import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DropdownInline } from 'src/components/dropdowns/DropdownInline';
import { IFilterTypeProperty } from 'src/components/FilterTypeProperty/types';
import {
  useChangeValue,
} from 'src/components/FilterTypeProperty/hooks';
import { getInfrastructureFilters } from 'src/store/infrastructure/selectors';
import { getListOfTypeDisplayedSpinner } from 'src/store/type-displayed-spinner/selectors';
import { useAppVisibilityBtn, useBuildType, useLanguageState } from 'src/hooks';
import { useTranslations } from 'src/hooks/translataions';
import { locals } from 'src/constants/locals';
import { useGetRequestAppData } from 'src/hooks/app';
import { IFrontConfigTypeEnum } from 'src/typings/table';

export const FilterTypeProperty: React.FC<IFilterTypeProperty> = ({
  title,
}) => {
  const { getTranslations } = useTranslations();
  const infrastructureFilter = useSelector(getInfrastructureFilters);
  const listOfType = useSelector(getListOfTypeDisplayedSpinner);
  const { handleChangeType } = useChangeValue(listOfType);
  const { appRequestData } = useGetRequestAppData();
  const { isCrossTable } = useBuildType();
  const { currentAppLanguage } = useLanguageState();
  const [sortedList, setSortedList] = useState<string[]>([]);
  const { show_prefilter_placement_type_selector: showPrefilterPlacementTypeSelector } = useAppVisibilityBtn();

  useEffect(() => {
    const list: string[] = [];
    const viewsType = isCrossTable
      ? IFrontConfigTypeEnum.adminPanel
      : IFrontConfigTypeEnum.website;

    listOfType.forEach((type) => {
      const { title: placementTile, frontConfig } = type;
      const views = frontConfig[viewsType]
        .views
        .filter((view) => view.isEnabled).length;

      if (views && frontConfig[viewsType].isActive && placementTile[currentAppLanguage]) {
        list.push(placementTile[currentAppLanguage]);
      }
    });

    if (infrastructureFilter && !!Object.keys(infrastructureFilter).length) {
      list.push(locals.appTranslations.appInfrastructure);
    }

    setSortedList(list);
  }, [listOfType, infrastructureFilter, currentAppLanguage]);

  return sortedList.length > 1 && showPrefilterPlacementTypeSelector ? (
    <div>
      {title ? getTranslations(title) : ''}
      {' '}
      {showPrefilterPlacementTypeSelector && (
        <>
          <DropdownInline
            dropdownInfo={sortedList}
            onChange={handleChangeType}
          />
          {' '}
          {isCrossTable ? getTranslations(locals.appTranslations.appFromIn) : ''}
          {' '}
          {isCrossTable ? appRequestData?.crosstable_title : ''}
        </>
      )}
    </div>
  ) : null;
};
